import { ChangeDetectorRef, Component, Inject, LOCALE_ID, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

import { AuthService } from "src/app/_app-core/services/auth/auth.service";
import { PosService } from "src/app/_services/posService";
import { Grn } from "../../../_models/table-models";

import { formatDate } from "@angular/common";
import { DataExportService } from "src/app/_services/dataExportService";
import { PodService } from "src/app/_services/pod.service";

@Component({
  selector: "app-proof-of-delivery",
  templateUrl: "./proof-of-delivery.component.html",
  styleUrls: ["./proof-of-delivery.component.scss"],
})
export class ProofOfDeliveryComponent implements OnInit {
  searchTerm: string = "";
  pods: Grn[] = [];
  selectedItems = [];
  responseData: any;
  isError: any;
  isEmpty = false;
  loading = true;
  all = false;
  isSelected = false;
  displayName: any;
  page = 1;
  pageSize = 10;
  collectionSize: any;
  proof: any;
  poNo: any;
  comparable: any;
  allSubmited = false;
  filterBy: any = "docNoNumberOrString";
  sessionExpired = false;
  errorMsg = "";
  isCondensed: boolean = false;
  currentLayout = {
    isCondensed: true,
  };
  selectedOption = true;
  tableData: any;
  impersonate;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private posService: PosService,
    private cdref: ChangeDetectorRef,
    private authService: AuthService,
    private exportService: DataExportService,
    private podService: PodService,
    @Inject(LOCALE_ID) public locale: string
  ) {}

  toggleSidebar() {
    this.currentLayout.isCondensed = !this.currentLayout.isCondensed;
    document.body.setAttribute("data-sidebar-size", this.currentLayout.isCondensed ? "condensed" : "default");
  }

  ngOnInit(): void {
    this.poNo = this.route.snapshot.params["poNo"];
    if (localStorage.getItem("impersonation") === null || localStorage.getItem("impersonation") === "") {
      this.impersonate = "false";
    } else {
      this.impersonate = localStorage.getItem("impersonation");
    }

    const userData = {
      poNo: this.poNo,
      action: "list",
      sellerCode: localStorage.getItem("vendorCode"),
      session: { sessionId: localStorage.getItem("eippSession") },
    };

    this.fetchPurchaseOrders();
  }

  fetchPurchaseOrders() {
    this.loading = true;
    const userData = {
      sortConfig: {
        field: "updateTime",
        order: "desc",
      },
      pageSize: this.pageSize,
      pageNo: this.page,
      filters: [
        {
          key: "docType",
          value: "POD",
        },
        {
          key: "poNoNumberOrString",
          value: this.poNo,
        },
        {
          key: "cancelled",
          value: "FALSE",
        }
      ],
      sellercode: this.authService.getSellerCode(),
      isExport: false,
      linkFilters: [],
      isAP: true,
      isPOD: true,
    };
    if(this.searchTerm !== "") {
      userData.filters.push({
        key: this.filterBy,
        value: this.searchTerm,
      });
    }

    this.posService.fetchPurchaseOrders(userData).subscribe(
      (res) => {
        this.loading = false;
        this.responseData = res;

        if (this.responseData.code == 200) {
          const storedPo = this.podService.getStoredPo && this.podService.getStoredPo();
          this.pods = this.responseData.data.list.map((r: any) => ({
            checked: false,
            ...r,
            erpDocType: storedPo?.erpDocType,
            purchaseOrg: storedPo?.purchaseOrg,
            cmpCode: storedPo?.cmpCode,
          }));

          this.collectionSize = this.responseData.data.noOfRecords;
          // this.refreshPos();
          //  this.refreshPo();
          this.proof = this.pods;

          let comparable = [];
          this.pods.forEach((p: any) => {
            if (p.apinvMatching?.apinv?.length > 0) {
              p.invoiceStatus = "Invoiced";
            } else {
              p.invoiceStatus = "Not Invoiced";
            }
            if (p.invoiceStatus === "Invoiced" || (p.invoiceStatus === "Not Invoiced" && p.qualityInspectStatus === "FALSE")) {
              comparable.push(p);
            }
          });

          if (comparable.length === this.pods.length) {
            this.allSubmited = true;
          }
          if (this.responseData.data.list.length === 0) {
            this.loading = false;
            this.isEmpty = true;
          } else {
            this.loading = false;
            this.isEmpty = false;
          }
        } else {
          this.loading = false;
          this.isEmpty = true;
        }
      },
      (error) => {
        if (error.status === 401) {
          this.sessionExpired = true;
          this.errorMsg = error.error.msg;
          this.loading = false;
        }
      }
    );
  }

  accountLogout() {
    const userData = {
      session: { sessionId: localStorage.getItem("eippSession") },
    };
    this.authService.logOut(userData).subscribe(
      (res) => {
        const responseData: any = res;
        if (responseData.status === "ok") {
          localStorage.clear();
          this.router.navigateByUrl("/");
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  // ngAfterContentChecked() {
  //     this.cdref.detectChanges();
  // }

  checkAll(ev: any) {
    this.proof.forEach((x: any, i: number) => {
      x.checked = ev.target.checked;
      this.onCheckboxChange(i);
    });
  }

  isAllCheck() {
    this.onSelectChanges();
    return this.proof.every((p: any) => p.checked);
  }

  onSelectChanges() {
    const itemsChecked = this.proof.filter((p: any) => p.checked);

    // itemsChecked.forEach((item) => {
    //     this.selectedItems.push(item);
    //     console.log(this.selectedItems);
    // });
  }

  onCheckboxChange(index: number) {
    const isChecked = this.proof[index]?.checked ?? false;
    if (isChecked) {
      // Check if the item is already in the selectedItems array
      const exists = this.selectedItems.some((item) => item.id === this.proof[index].id && item.po_item_line === this.proof[index].po_item_line);

      // Only add the item if it's not already in the array
      if (!exists) {
        this.selectedItems.push(this.proof[index]);
      }
    } else {
      const selectedIndex = this.selectedItems.findIndex((item) => item.id === this.proof[index].id);
      if (selectedIndex !== -1) {
        this.selectedItems.splice(selectedIndex, 1);
      }
    }

    this.isSelected = this.selectedItems.length !== 0;
  }

  sendPod(pod = null) {
    if (pod !== null) {
      console.log(pod + " this is the null value");
    } else {
      const selectedPods: any = [];
      // this.proof.forEach((p: any) => {
      //     if (p.checked === true) {
      //         selectedPods.push(p);
      //     }
      //     console.log(selectedPods);

      // });
      if (this.selectedItems.length !== 0) {
        //console.log(this.selectedItems);
        localStorage.setItem("pods", JSON.stringify(this.selectedItems));
        this.router.navigate(["/submit-invoice", this.poNo]);
      }
    }
  }

  refreshPo() {
    // this.proof = this.pods;
    this.fetchPurchaseOrders();
    // let sortedPods = this.pods.sort((a, b) =>
    //     a.grn_no > b.grn_no ? 1 : -1
    // );
    // this.proof = sortedPods
    //     .map((po: any, i: any) => ({
    //         id: i + 1,
    //         ...po,
    //         checked: this.selectedItems.some(
    //             (selected: any) => selected.id === i + 1
    //         ),
    //     }))
    //     .slice(
    //         (this.page - 1) * this.pageSize,
    //         (this.page - 1) * this.pageSize + this.pageSize
    //     );
  }

  onFilter(option: any) {
    this.filterBy = option.target.value;
    this.selectedOption = true;
  }

  onSearch(event: KeyboardEvent) {
    this.searchTerm = (event.target as HTMLInputElement).value;
    this.fetchPurchaseOrders();
  }

  generalSearch(event: KeyboardEvent) {
    this.searchTerm = (event.target as HTMLInputElement).value;

    if (this.searchTerm !== "") {
      this.proof = this.pods.filter(
        (data) =>
          (data.grn_no as string).toLowerCase().includes(this.searchTerm.toLowerCase()) ||
          data.invoice_number.toString().toLowerCase().includes(this.searchTerm.toLowerCase()) ||
          data.grn_year.toString().toLowerCase().includes(this.searchTerm.toLowerCase()) ||
          data.po_item_line.toString().toLowerCase().includes(this.searchTerm.toLowerCase()) ||
          data.grn_quantity.toString().toLowerCase().includes(this.searchTerm.toLowerCase()) ||
          (data.invoiceStatus as string).toLowerCase().includes(this.searchTerm.toLowerCase()) ||
          (data.grn_delivery_date as string).toLowerCase().includes(this.searchTerm.toLowerCase())
      );
    } else {
      this.proof = this.pods;
    }
  }

  exportToExcel() {
    const date = new Date();

    const fileName = (this.displayName = localStorage.getItem("vendorCode")) + "_GRN_Table_" + formatDate(date, "dd_MM_yyyy_h_mm_a", this.locale);

    if (this.selectedOption === false) {
      this.tableData = this.pods;
    } else {
      this.tableData = this.proof;
    }

    const cols = [
      {
        name: "GRN No",
        colKey: "grn_no",
      },
      {
        name: "GRN Invoice No",
        colKey: "invoice_number",
      },
      {
        name: "Year",
        colKey: "grn_year",
      },
      {
        name: "Item Code",
        colKey: "item_code",
      },
      {
        name: "Line Item",
        colKey: "po_item_line",
      },
      {
        name: "GRN Quantity",
        colKey: "grn_quantity",
      },
      {
        name: "Delivery Date",
        colKey: "grn_delivery_date",
      },
      {
        name: "Invoicing Status",
        colKey: "invoiceStatus",
      },
    ];

    this.exportService.exportToExcel(this.tableData, cols, fileName);
  }
}
